class PromoSwiper extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
    this.slides = this.querySelectorAll(".promo-products__slide.swiper-slide")
  }

  connectedCallback() {
    this.initSwiper()
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.slides.length > 4 ? 4.2 : 4,
      spaceBetween: 5,
      freeMode: true,
      cssMode : true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    })
  }
}

customElements.define("hh-promo-swiper", PromoSwiper)
